// Polnisches Woerterbuch der Checkout-App. Anrede Ty (gross), neutral statt maennlich (Epic 160). reference: [lang 1]
export default {
    // Checkout.svelte
    'Artikel konnte nicht hinzugefügt werden': 'Nie udało się dodać produktu',
    'Aus Sicherheitsgründen wurdest du nach längerer Inaktivität abgemeldet. Bitte starte deinen Checkout neu — dein Warenkorb wird gleich aktualisiert.': 'Ze względów bezpieczeństwa nastąpiło wylogowanie po dłuższej bezczynności. Rozpocznij zamówienie od nowa — za chwilę zaktualizujemy Twój koszyk.',
    'Bitte wähle eine andere Zahlungsart.': 'Wybierz inną metodę płatności.',
    'Dein Warenkorb hat sich geändert. Bitte starte EasyCredit erneut.': 'Twój koszyk się zmienił. Uruchom easyCredit ponownie.',
    'Deine Bestellung wird vorbereitet…': 'Przygotowujemy Twoje zamówienie…',
    'Deine Sitzung ist abgelaufen': 'Twoja sesja wygasła',
    'Schließen': 'Zamknij',
    'Zum Warenkorb': 'Do koszyka',
    'easyCredit-Ratenkauf abgebrochen': 'Zakup na raty easyCredit został przerwany',
    'Amazon Pay hat die Zahlung abgelehnt. Bitte wähle eine andere Zahlungsart.': 'Amazon Pay odrzucił płatność. Wybierz inną metodę płatności.',
    'Amazon konnte die Zahlung nicht abschließen. Bitte wähle eine andere Zahlungsart.': 'Amazon nie mógł sfinalizować płatności. Wybierz inną metodę płatności.',
    'Du hast die Amazon Pay Zahlung abgebrochen. Bitte wähle eine andere Zahlungsart.': 'Anulowano płatność Amazon Pay. Wybierz inną metodę płatności.',
    // Component/AddressAutocomplete.svelte
    '123': '12',
    'Adresse *': 'Adres *',
    'Adresse eingeben (wird automatisch vervollständigt)': 'Wpisz adres (zostanie uzupełniony automatycznie)',
    'Hausnummer *': 'Numer domu *',
    'Kim Muster': 'Anna Kowalska',
    'Land *': 'Kraj *',
    'Musterstraße': 'ul. Przykładowa',
    'Ort *': 'Miejscowość *',
    'PLZ *': 'Kod pocztowy *',
    'Straße *': 'Ulica *',
    'Vollständiger Name *': 'Imię i nazwisko *',
    // Component/AddressCard.svelte
    'Adresse löschen': 'Usuń adres',
    'Postnummer: {nummer}': 'Numer Postnummer: {nummer}',
    // Component/AddressForm.svelte
    '+ Adresszusatz hinzufügen': '+ Dodaj dodatek do adresu',
    '+ Firmendaten hinzufügen': '+ Dodaj dane firmy',
    '- Adresszusatz entfernen': '- Usuń dodatek do adresu',
    '- Firmendaten entfernen': '- Usuń dane firmy',
    '2. Stock, Hinterhaus': '2. piętro, oficyna',
    'Adresszusatz': 'Dodatek do adresu',
    'DE123456789': 'PL1234567890',
    'Firma': 'Firma',
    'Musterfirma GmbH': 'Przykładowa Firma Sp. z o.o.',
    'USt-IdNr.': 'Numer VAT UE',
    // Component/AddressValidationModal.svelte
    'Adresse bearbeiten': 'Edytuj adres',
    'Deine Adresse muss korrigiert werden': 'Twój adres wymaga poprawy',
    'Deine Eingabe': 'Wpisane dane',
    'Diese Adresse konnte nicht gefunden werden': 'Nie znaleziono tego adresu',
    'Mehrere mögliche Adressen gefunden': 'Znaleziono kilka możliwych adresów',
    'Original übernehmen': 'Zostaw wpisany adres',
    'Vorschlag': 'Propozycja',
    'Vorschlag übernehmen': 'Użyj propozycji',
    'Wir empfehlen den unten gezeigten Vorschlag, damit deine Lieferung sicher ankommt.': 'Zalecamy skorzystanie z propozycji poniżej, aby Twoja przesyłka na pewno dotarła.',
    'Wir haben mehrere mögliche Treffer. Bitte prüfe den Vorschlag.': 'Znaleźliśmy kilka możliwych adresów. Sprawdź propozycję.',
    'Wir konnten deine Adresse nicht zweifelsfrei finden. Du kannst trotzdem mit deiner Eingabe fortfahren oder sie bearbeiten.': 'Nie udało się jednoznacznie znaleźć Twojego adresu. Możesz mimo to kontynuować z wpisanymi danymi albo je poprawić.',
    'Wir konnten deine Adresse nicht zweifelsfrei prüfen. Bitte überprüfe sie oder fahre mit deiner Eingabe fort.': 'Nie udało się jednoznacznie zweryfikować Twojego adresu. Sprawdź go albo kontynuuj z wpisanymi danymi.',
    // Component/BasketActions.svelte
    'Express Checkout': 'Express Checkout',
    // Component/BasketItem.svelte
    'Anzahl: ': 'Ilość:',
    'Artikel entfernen': 'Usuń produkt',
    'Menge:': 'Ilość:',
    // Component/BasketSum.svelte
    'Gesamtsumme': 'Suma całkowita',
    'Gesamtsumme:': 'Suma całkowita:',
    'gratis': 'gratis',
    // Component/BikeInsuranceWidget.svelte
    '*nicht möglich bei Fahrradleasing': '*niedostępne przy leasingu roweru',
    'Bitte akzeptiere die Versicherungsbedingungen.': 'Zaakceptuj warunki ubezpieczenia.',
    'Bitte gib dein Geburtsdatum ein.': 'Podaj datę urodzenia.',
    'Bitte stimme der Datenweitergabe zu.': 'Wyraź zgodę na przekazanie danych.',
    'Das Alter darf 80 Jahre nicht überschreiten.': 'Wiek nie może przekraczać 80 lat.',
    'Die Versicherung kann nur für Räder mit einem Gesamtwert bis maximal {max} abgeschlossen werden. Der aktuelle Gesamtwert beträgt {total}.': 'Ubezpieczenie można zawrzeć tylko dla rowerów o łącznej wartości do {max}. Aktualna łączna wartość wynosi {total}.',
    'Du musst mindestens 18 Jahre alt sein.': 'Musisz mieć ukończone 18 lat.',
    'Geburtsdatum für Versicherungsschutz': 'Data urodzenia do ochrony ubezpieczeniowej',
    'Ich akzeptiere die <a href="https://bikmo.com/at/documents/at-fahrrad-avb/" class="underline" target="_blank" rel="noopener">AVB</a>, bestätige, dass ich die <a href="https://support.bikmo.com/hc/en-us/articles/115005866249-Eignungskriterien" class="underline" target="_blank" rel="noopener">Eignungskriterien</a> erfülle, und habe das <a href="https://bikmo.com/at/documents/at-fahrrad-ipid/" class="underline" target="_blank" rel="noopener">Produktinformationsblatt</a> zur Versicherung sowie die Datenschutzerklärung gelesen und verstanden.': 'Akceptuję <a href="https://bikmo.com/at/documents/at-fahrrad-avb/" class="underline" target="_blank" rel="noopener">OWU</a>, potwierdzam, że spełniam <a href="https://support.bikmo.com/hc/en-us/articles/115005866249-Eignungskriterien" class="underline" target="_blank" rel="noopener">kryteria kwalifikacyjne</a>, oraz potwierdzam zapoznanie się z <a href="https://bikmo.com/at/documents/at-fahrrad-ipid/" class="underline" target="_blank" rel="noopener">dokumentem informacyjnym o produkcie ubezpieczeniowym</a> i z polityką prywatności oraz ich zrozumienie.', // TODO(pl) rechtlich prüfen, Bikmo nur DE/AT
    'Ich bin einverstanden, meine persönlichen Daten mit der Bikmo GmbH zu teilen.': 'Wyrażam zgodę na przekazanie moich danych osobowych firmie Bikmo GmbH.',
    'Ja, ich möchte die kostenlose 30-Tage-Versicherung hinzufügen': 'Tak, chcę dodać bezpłatne 30-dniowe ubezpieczenie',
    'Mit Fahrradleasing ist die 30-Tage-Versicherung nicht kombinierbar. Wähle eine andere Zahlungsart, wenn du sie behalten möchtest.': 'Ubezpieczenia 30-dniowego nie można łączyć z leasingiem roweru. Wybierz inną metodę płatności, jeśli chcesz je zachować.',
    'Schutz bei Diebstahl, Vandalismus & Unfallschäden. Endet automatisch.': 'Ochrona na wypadek kradzieży, wandalizmu i uszkodzeń w wypadkach. Wygasa automatycznie.',
    // Component/ConfirmModal.svelte
    'Abbrechen': 'Anuluj',
    'Bestätigen': 'Potwierdź',
    // Component/DeliveryDateSection.svelte
    '8-15 Uhr': '8:00–15:00',
    'An Feiertagen ist keine Zustellung möglich.': 'W dni ustawowo wolne od pracy nie realizujemy dostaw.',
    'Bitte wähle Dein Zustelldatum': 'Wybierz termin dostawy',
    'Du kannst hier ein fixes Zustelldatum angeben. Die Zustellung erfolgt am gewählten Datum zwischen 8 und 15 Uhr morgens. Wenn du kein Datum angibst, kontaktieren wir dich vor Versand und machen ein Zustelldatum mit dir aus.': 'Możesz tu podać stały termin dostawy. Dostawa nastąpi w wybranym dniu między 8:00 a 15:00. Jeśli nie podasz terminu, skontaktujemy się z Tobą przed wysyłką i ustalimy termin dostawy.',
    'Frühestes mögliches Lieferdatum überschritten — bitte späteres Datum wählen.': 'Wybrany termin jest wcześniejszy niż najwcześniejszy możliwy termin dostawy — wybierz późniejszą datę.',
    'Samstags ist keine Zustellung möglich.': 'W soboty nie realizujemy dostaw.',
    'Sonntags ist keine Zustellung möglich.': 'W niedziele nie realizujemy dostaw.',
    'Termin entfernen': 'Usuń termin',
    'Ungültiges Datum.': 'Nieprawidłowa data.',
    'Wunsch-Zustelldatum konnte nicht gespeichert werden. Bitte versuche es erneut.': 'Nie udało się zapisać wybranego terminu dostawy. Spróbuj ponownie.',
    'Wunschtermin gespeichert': 'Termin zapisany',
    // Component/EuGuaranteeNotice.svelte
    'Deine {link}': 'Twoje {link}',
    'EU-Hinweis zur gesetzlichen Gewährleistung': 'Informacja UE o ustawowej rękojmi',
    'Gesetzliche Gewährleistung': 'Ustawowa rękojmia',
    'Gewährleistungsrechte': 'prawa z tytułu rękojmi',
    'Mehr dazu im EU-Portal „Ihr Europa“ (europa.eu/youreurope/garantien)': 'Więcej informacji na portalu UE „Twoja Europa”',
    // Component/ExpressPayments.svelte
    'Wird geladen...': 'Ładowanie...',
    // Component/LeasingWidget.svelte
    'Leasing-Widget konnte nicht geladen werden.': 'Nie udało się załadować widżetu leasingu.',
    'Leasing-Widget wird geladen…': 'Ładowanie widżetu leasingu…',
    // Component/OrderRemark.svelte
    'Hier kannst du uns noch etwas mitteilen.': 'Tutaj możesz przekazać nam dodatkowe informacje.',
    'Mitteilung hinzufügen': 'Dodaj wiadomość',
    // Component/Packstation.svelte
    '24/7 geöffnet': 'Otwarte całodobowo (24/7)',
    'Ausgewählt': 'Wybrano',
    'Auswählen': 'Wybierz',
    'Fehler bei der Suche.': 'Błąd wyszukiwania.',
    'Keine Packstationen gefunden.': 'Nie znaleziono punktów Packstation.',
    'Lade Stationen...': 'Ładowanie punktów...',
    'PLZ oder Ort eingeben': 'Wpisz kod pocztowy lub miejscowość',
    'Packstation finden': 'Znajdź Packstation',
    'Suche eine PLZ oder einen Ort, um Packstationen anzuzeigen.': 'Wpisz kod pocztowy lub miejscowość, aby wyświetlić punkty Packstation.',
    'Suchen': 'Szukaj',
    'Suchen Sie nach einer DHL Packstation in Ihrer Nähe und wählen Sie einen geeigneten Standort für die Lieferung aus.': 'Wyszukaj punkt DHL Packstation w swojej okolicy i wybierz odpowiednią lokalizację dostawy.',
    'Suchergebnisse ({shown} von {total})': 'Wyniki wyszukiwania ({shown} z {total})',
    'Suchergebnisse ({total})': 'Wyniki wyszukiwania ({total})',
    'z.B. 10115 oder Berlin': 'np. 10115 lub Berlin',
    // Component/Payments/AmazonPay.svelte
    'Amazon Pay Button nicht initialisiert. Bitte Seite neu laden.': 'Przycisk Amazon Pay nie został zainicjowany. Odśwież stronę.',
    'Amazon Pay Konfiguration nicht verfügbar.': 'Konfiguracja Amazon Pay jest niedostępna.',
    // Component/Payments/AmazonPayExpress.svelte
    'Amazon Pay Express Konfiguration nicht verfügbar.': 'Konfiguracja Amazon Pay Express jest niedostępna.',
    'Amazon Pay JS SDK konnte nicht geladen werden.': 'Nie udało się załadować Amazon Pay JS SDK.',
    'Amazon Pay konnte nicht geladen werden. Bitte Seite neu laden.': 'Nie udało się załadować Amazon Pay. Odśwież stronę.',
    'Bezahlen über': 'Zapłać przez',
    'Netzwerkfehler beim Laden der Amazon Pay Konfiguration.': 'Błąd sieci podczas ładowania konfiguracji Amazon Pay.',
    // Component/Payments/EasyCredit.svelte
    'Weiter zu': 'Przejdź do',
    'easyCredit-Ratenkauf': 'easyCredit – zakup na raty',
    // Component/Payments/PaypalAcdc.svelte
    'Bitte gib den Karteninhaber ein.': 'Podaj imię i nazwisko posiadacza karty.',
    'Bitte gib den Sicherheitscode (CVC) ein.': 'Podaj kod bezpieczeństwa (CVC).',
    'Bitte gib ein gültiges Ablaufdatum ein.': 'Podaj prawidłową datę ważności.',
    'Bitte gib eine gültige Kartennummer ein.': 'Podaj prawidłowy numer karty.',
    'Bitte prüfe deine Kartendaten (Kartennummer, Ablaufdatum und Sicherheitscode).': 'Sprawdź dane karty (numer karty, datę ważności i kod bezpieczeństwa).',
    'Bitte prüfe deine Kartendaten.': 'Sprawdź dane karty.',
    'Gültig bis': 'Ważna do',
    'Karte abgelaufen.': 'Karta straciła ważność.',
    'Karte abgelehnt. Bitte andere Karte verwenden.': 'Karta odrzucona. Użyj innej karty.',
    'Karte bestätigen': 'Potwierdź kartę',
    'Karteninhaber': 'Posiadacz karty',
    'Kartennummer': 'Numer karty',
    'Kartenzahlung fehlgeschlagen. Bitte erneut versuchen.': 'Płatność kartą nie powiodła się. Spróbuj ponownie.',
    'Kreditkarte konnte nicht geladen werden. Bitte Seite neu laden.': 'Nie udało się załadować formularza karty. Odśwież stronę.',
    'Kreditkartenzahlung ist für diesen Warenkorb nicht verfügbar.': 'Płatność kartą kredytową jest niedostępna dla tego koszyka.',
    'Max Mustermann': 'Jan Kowalski',
    'PayPal ACDC SDK konnte nicht geladen werden': 'Nie udało się załadować PayPal ACDC SDK',
    'Sicherheitscode': 'Kod bezpieczeństwa',
    'Ungültige Kartennummer.': 'Nieprawidłowy numer karty.',
    'Ungültiger Sicherheitscode.': 'Nieprawidłowy kod bezpieczeństwa.',
    'Ungültiges Ablaufdatum.': 'Nieprawidłowa data ważności.',
    'Wird verarbeitet…': 'Przetwarzanie…',
    // Component/Payments/StripePayment.svelte
    'Meine Daten speichern für eine schnellere Kaufabwicklung': 'Zapisz moje dane, aby szybciej finalizować zakupy',
    'Die Zahlung konnte nicht geladen werden. Bitte Seite neu laden.': 'Nie udało się załadować płatności. Odśwież stronę.',
    'Zu dieser E-Mail-Adresse gibt es ein Kundenkonto. Bitte melde dich an, um fortzufahren.': 'Dla tego adresu e-mail istnieje konto klienta. Zaloguj się, aby kontynuować.',
    'Der Betrag hat sich geändert. Bitte versuche es erneut.': 'Kwota uległa zmianie. Spróbuj ponownie.',
    'Die Zahlung konnte nicht gestartet werden. Bitte versuche es erneut.': 'Nie udało się rozpocząć płatności. Spróbuj ponownie.',
    'Der Betrag hat sich geändert. Bitte bestätige die Zahlung mit deiner Karte erneut.': 'Kwota uległa zmianie. Potwierdź płatność kartą ponownie.',
    'Die Zahlung wurde nicht abgeschlossen. Bitte versuche es erneut oder wähle eine andere Zahlungsart.': 'Płatność nie została zakończona. Spróbuj ponownie lub wybierz inną metodę płatności.',
    'Zahlung wird geprüft…': 'Sprawdzamy płatność…',
    // Component/Payments/PaypalGateway.svelte
    'Bestellung konnte nicht erstellt werden.': 'Nie udało się utworzyć zamówienia.',
    'PayPal konnte nicht geladen werden. Bitte Seite neu laden.': 'Nie udało się załadować PayPal. Odśwież stronę.',
    'PayPal-Fehler. Bitte versuche es erneut.': 'Błąd PayPal. Spróbuj ponownie.',
    // Component/Payments/PaypalPui.svelte
    'Bitte gib ein gültiges Geburtsdatum ein (mind. 18 Jahre).': 'Podaj prawidłową datę urodzenia (min. 18 lat).',
    'Bitte gib eine gültige Telefonnummer ein (z.B. +49 30 123456789).': 'Podaj prawidłowy numer telefonu (np. +48 22 123 45 67).',
    'Falls deine Transaktion per Kauf auf Rechnung erfolgreich abgewickelt werden kann, wird der Kaufpreis an Ratepay abgetreten und du darfst nur an Ratepay überweisen, nicht an den Händler.': 'Jeżeli transakcja zakupu na fakturę zostanie zrealizowana pomyślnie, należność zostanie scedowana na Ratepay, a Ty możesz płacić wyłącznie na rzecz Ratepay, nie sprzedawcy.',
    'Für die Abwicklung des Rechnungskaufes benötigen wir dein Geburtsdatum sowie eine gültige Telefonnummer mit Orts- oder Ländervorwahl (z.B. 030 123456789 oder +49 30 123456789).': 'Do obsługi zakupu na fakturę potrzebujemy Twojej daty urodzenia oraz prawidłowego numeru telefonu z numerem kierunkowym kraju (np. +48 22 123 45 67).',
    'Geburtstag': 'Data urodzenia',
    'Mit Klicken auf den "Jetzt kaufen"-Button akzeptierst du die': 'Klikając przycisk „Kup teraz”, akceptujesz',
    'PayPals Datenschutzerklärung': 'politykę prywatności PayPal',
    'Ratepay Zahlungsbedingungen': 'warunki płatności Ratepay',
    'Risikoprüfung durch Ratepay': 'oceny ryzyka przez Ratepay',
    'Telefonnr.': 'Nr telefonu',
    'Wird geladen…': 'Ładowanie…',
    'und erklärst dich mit der Durchführung einer': 'i wyrażasz zgodę na przeprowadzenie',
    'unseren Partner, einverstanden. Du akzeptierst auch': 'naszego partnera. Akceptujesz również',
    // Component/PhoneBlock.svelte
    'Die Nummer wurde aus deinen Kontodaten übernommen und kann bei Bedarf geändert werden.': 'Numer pochodzi z danych Twojego konta i w razie potrzeby możesz go zmienić.',
    'Für die Zustellung deiner Bestellung benötigen wir deine Telefonnummer.': 'Do dostarczenia zamówienia potrzebujemy Twojego numeru telefonu.',
    'Telefonnummer': 'Numer telefonu',
    'Telefonnummer erforderlich': 'Numer telefonu jest wymagany',
    'Telefonnummer hinterlegt': 'Numer telefonu zapisany',
    // Component/ShippingMethodCard.svelte
    'Kostenlos': 'Bezpłatnie',
    // Component/VatValidationModal.svelte
    'Adresse korrigieren': 'Popraw adres',
    'Bei der Prüfung deiner USt-IdNr. stimmen nicht alle Angaben mit dem amtlichen Register überein:': 'Podczas weryfikacji Twojego numeru VAT UE nie wszystkie dane zgadzają się z urzędowym rejestrem:',
    'Du kannst deine Adresse korrigieren oder mit deinen Angaben fortfahren.': 'Możesz poprawić adres albo kontynuować z podanymi danymi.',
    'Trotzdem fortfahren': 'Kontynuuj mimo to',
    'USt-IdNr.-Prüfung': 'Weryfikacja numeru VAT UE',
    // Steps/Basket.svelte
    '100 Tage Rückgabegarantie': '100-dniowa gwarancja zwrotu',
    'Akkus können nicht zusammen mit anderen Artikeln bestellt werden. Bitte entferne entweder die Akkus oder alle anderen Artikel aus deinem Warenkorb.': 'Akumulatorów nie można zamawiać razem z innymi produktami. Usuń z koszyka albo akumulatory, albo wszystkie pozostałe produkty.',
    'Artikel nicht mehr verfügbar:': 'Produkty nie są już dostępne:',
    'Bitte beachte:': 'Pamiętaj:',
    'Dein Warenkorb': 'Twój koszyk',
    'Dein Warenkorb ist leer': 'Twój koszyk jest pusty',
    'Deine Bestellung': 'Twoje zamówienie',
    'Füge Artikel hinzu, um mit dem Einkauf zu beginnen.': 'Dodaj produkty, aby rozpocząć zakupy.',
    'Hinweis:': 'Uwaga:',
    'Overnight Express Lieferung möglich': 'Możliwa dostawa Overnight Express',
    'Sicher zur Kasse gehen': 'Bezpiecznie do kasy',
    'Sichere Verschlüsselung & 100% Datenschutz': 'Bezpieczne szyfrowanie i 100% ochrony danych',
    'fahrfertig montiert': 'zmontowany i gotowy do jazdy',
    'oder': 'lub',
    'schneller Versand': 'szybka wysyłka',
    'Deine Bestellung wird voraussichtlich in {days} Tag versendet, da die Artikel zu unterschiedlichen Zeiten versandfertig sind und wir alles zusammen verschicken.': 'Twoje zamówienie zostanie prawdopodobnie wysłane w ciągu {days} dnia, ponieważ produkty są gotowe do wysyłki w różnych terminach, a wysyłamy wszystko razem.',
    'Deine Bestellung wird voraussichtlich in {days} Tagen versendet, da die Artikel zu unterschiedlichen Zeiten versandfertig sind und wir alles zusammen verschicken.': 'Twoje zamówienie zostanie prawdopodobnie wysłane w ciągu {days} dni, ponieważ produkty są gotowe do wysyłki w różnych terminach, a wysyłamy wszystko razem.',
    // Steps/Order.svelte
    'AGB': 'Regulamin',
    'Bearbeiten': 'Edytuj',
    'Bestellung wird aufgegeben…': 'Składanie zamówienia…',
    'Der Betrag hat sich geändert. Bitte bestätige die Zahlung erneut bei PayPal, um deinen Kauf abzuschließen.': 'Kwota uległa zmianie. Potwierdź płatność ponownie w PayPal, aby sfinalizować zakup.',
    'Der Betrag hat sich geändert. Bitte bestätige die Zahlung erneut über PayPal.': 'Kwota uległa zmianie. Potwierdź płatność ponownie przez PayPal.',
    'Du hast die PayPal-Zahlung abgebrochen. Bitte bestätige sie erneut, um deinen Kauf abzuschließen.': 'Anulowano płatność PayPal. Potwierdź ją ponownie, aby sfinalizować zakup.',
    'Fahrradleasing': 'Leasing roweru',
    'Fehler beim Bestellen.': 'Błąd podczas składania zamówienia.',
    'Ich habe die {agb} und die {widerruf} gelesen und stimme diesen zu.': 'Akceptuję {agb} i {widerruf}.', // TODO(pl) rechtlich prüfen
    'Ich möchte die Bestellung trotzdem aufgeben.': 'Mimo to chcę złożyć zamówienie.',
    'Jetzt kaufen': 'Kup teraz',
    'Kartenzahlung konnte nicht bestätigt werden. Bitte prüfe deine Kartendaten (Ablaufdatum und Sicherheitscode) und versuche es erneut.': 'Nie udało się potwierdzić płatności kartą. Sprawdź dane karty (datę ważności i kod bezpieczeństwa) i spróbuj ponownie.',
    'Leasing': 'Leasing',
    'Liefer- und Rechnungsadresse': 'Adres dostawy i adres do faktury',
    'Lieferadresse': 'Adres dostawy',
    'Netzwerkfehler. Bitte versuche es erneut.': 'Błąd sieci. Spróbuj ponownie.',
    'Rechnungsadresse': 'Adres do faktury',
    'Versand': 'Wysyłka',
    'Versand & Zahlung': 'Wysyłka i płatność',
    'Widerrufsbelehrung': 'pouczenie o prawie odstąpienia od umowy',
    'Wunsch-Zustelldatum': 'Wybrany termin dostawy',
    'Zahlung': 'Płatność',
    'Zahlung bei PayPal bestätigen': 'Potwierdź płatność w PayPal',
    'Überprüfen & Kaufen': 'Sprawdź i kup',
    // Steps/Payment.svelte
    'Die kostenlose 30-Tage-Versicherung wurde entfernt: sie ist mit Fahrradleasing nicht kombinierbar. Wähle eine andere Zahlungsart, wenn du sie behalten möchtest.': 'Bezpłatne 30-dniowe ubezpieczenie zostało usunięte: nie można go łączyć z leasingiem roweru. Wybierz inną metodę płatności, jeśli chcesz je zachować.',
    'Leider können wir dieses Produkt nicht in das ausgewählte Lieferland verschicken.': 'Niestety nie możemy wysłać tego produktu do wybranego kraju dostawy.',
    'Versand- und Zahlungsoptionen werden geladen…': 'Ładowanie opcji wysyłki i płatności…',
    'Versandart': 'Metoda wysyłki',
    'Weiter zur Überprüfung': 'Przejdź do sprawdzenia zamówienia',
    'Wähle deinen Leasinganbieter': 'Wybierz dostawcę leasingu',
    'Zahlungsart': 'Metoda płatności',
    'Zahlungsmethode ändern': 'Zmień metodę płatności',
    // Steps/ThankYou.svelte
    'Bitte beachte: Wir versenden dein Fahrrad erst, sobald wir die Freigabe durch deinen Leasing-Anbieter erhalten haben.': 'Uwaga: wyślemy Twój rower dopiero po otrzymaniu zgody od dostawcy leasingu.',
    'Eine Bestätigungs-E-Mail wurde an deine angegebene E-Mail-Adresse versendet.': 'Wiadomość z potwierdzeniem została wysłana na podany adres e-mail.',
    'Ja, Konto anlegen': 'Tak, załóż konto',
    'Ja, ich möchte eine Bewertungs-E-Mail erhalten': 'Tak, chcę otrzymać e-mail z prośbą o opinię',
    'Vielen Dank für deine Bestellung!': 'Dziękujemy za Twoje zamówienie!',
    'Wir haben dir eine E-Mail zum Festlegen deines Passworts geschickt.': 'Wysłaliśmy Ci e-mail do ustawienia hasła.',
    'Wird gesendet…': 'Wysyłanie…',
    // Steps/User.svelte
    '+ Ausgewählte Adresse bearbeiten': '+ Edytuj wybrany adres',
    '+ Neue Adresse hinzufügen': '+ Dodaj nowy adres',
    '+ Rechnungsadresse bearbeiten': '+ Edytuj adres do faktury',
    'ABBRECHEN': 'ANULUJ',
    'Adressen bearbeiten:': 'Edytuj adresy:',
    'An eine DHL Packstation': 'Do punktu DHL Packstation',
    'An meine Adresse liefern': 'Dostarcz pod mój adres',
    'Anmelden': 'Zaloguj się',
    'Anmeldung fehlgeschlagen. Bitte überprüfe deine Zugangsdaten.': 'Logowanie nie powiodło się. Sprawdź dane logowania.',
    'Bereits Kunde? Hier anmelden': 'Masz już konto? Zaloguj się tutaj',
    'Bitte gib Vor- und Nachname ein.': 'Podaj imię i nazwisko.',
    'Bitte gib deine DHL Postnummer ein.': 'Podaj swój numer DHL Postnummer.',
    'Bitte gib eine Hausnummer ein.': 'Podaj numer domu.',
    'Bitte gib eine Postleitzahl ein.': 'Podaj kod pocztowy.',
    'Bitte gib eine Straße ein.': 'Podaj ulicę.',
    'Bitte gib eine gültige E-Mail-Adresse ein.': 'Podaj prawidłowy adres e-mail.',
    'Bitte gib einen Ort ein.': 'Podaj miejscowość.',
    'Bitte prüfe zuerst deine Adresse — wir haben einen möglichen Korrekturvorschlag.': 'Najpierw sprawdź swój adres — mamy propozycję poprawki.',
    'Bitte wähle ein Land.': 'Wybierz kraj.',
    'Bitte wähle eine Packstation aus.': 'Wybierz punkt Packstation.',
    'Bitte wähle eine andere Lieferadresse oder ändere die Lieferadresse in deinem PayPal-Konto.': 'Wybierz inny adres dostawy lub zmień adres dostawy w swoim koncie PayPal.',
    'Dein Passwort': 'Twoje hasło',
    'Deine DHL Postnummer': 'Twój numer DHL Postnummer',
    'Diese E-Mail-Adresse konnte nicht registriert werden. Hast du bereits ein Kundenkonto bei uns?': 'Nie udało się zarejestrować tego adresu e-mail. Masz już u nas konto klienta?',
    'E-Mail-Adresse *': 'Adres e-mail *',
    'Flexible Abholung bei DHL': 'Elastyczny odbiór w DHL',
    'Gespeicherte Lieferadressen:': 'Zapisane adresy dostawy:',
    'Gespeicherte Rechnungsadresse:': 'Zapisany adres do faktury:',
    'Hallo': 'Cześć',
    'Identisch zur Rechnungsadresse': 'Taki sam jak adres do faktury',
    'Ja, ich möchte per E-Mail informiert werden': 'Tak, chcę otrzymywać informacje e-mailem',
    'Jetzt prüfen': 'Sprawdź teraz',
    'Kontakt & Lieferadresse': 'Kontakt i adres dostawy',
    'Liefer- und Rechnungsadresse:': 'Adres dostawy i adres do faktury:',
    'Lieferadresse löschen': 'Usuń adres dostawy',
    'Lieferadresse:': 'Adres dostawy:',
    'Lieferart wählen': 'Wybierz sposób dostawy',
    'Lieferung an deine Wunschadresse': 'Dostawa pod wskazany przez Ciebie adres',
    'Löschen': 'Usuń',
    'Meine Rechnungsadresse ist mit der Lieferadresse identisch': 'Mój adres do faktury jest taki sam jak adres dostawy',
    'Möchtest du diese Lieferadresse wirklich entfernen? Das kann nicht rückgängig gemacht werden.': 'Czy na pewno chcesz usunąć ten adres dostawy? Tej operacji nie można cofnąć.',
    'Passwort': 'Hasło',
    'Postnummer *': 'Numer Postnummer *',
    'Rechnungsadresse bearbeiten:': 'Edytuj adres do faktury:',
    'Rechnungsadresse:': 'Adres do faktury:',
    'Speichern': 'Zapisz',
    'Weiter zu Versand & Zahlung': 'Dalej do wysyłki i płatności',
    'Wir versenden nicht in das ausgewählte Lieferland.': 'Nie wysyłamy do wybranego kraju dostawy.',
    'Wir versenden nicht nach {land}.': 'Nie wysyłamy do kraju: {land}.',
    'Wird angemeldet...': 'Logowanie...',
    'Wird gespeichert...': 'Zapisywanie...',
    'deine.email@beispiel.de': 'twoj.email@przyklad.pl',
    'ÄNDERN': 'ZMIEŃ',
    'Ändern': 'Zmień',
    'Über Amazon Pay übermittelt': 'Przekazano przez Amazon Pay',
    // deliveryDate.js
    'Std.': 'godz.',
    'Stdn.': 'godz.',
    // dynamisch
    'Leasing Markup ({pct}%)': 'Leasing Markup ({pct}%)', // TODO(pl) Leasing nur DE, bleibt deutsch
    'Zinsen Ratenkauf': 'Odsetki (zakup na raty)',
    'Zwischensumme': 'Suma częściowa',
    'inkl. gesetzl. MwSt.': 'z ustawowym VAT',
    'ohne MwSt.': 'bez VAT',
    // lib/basketStore.svelte.js
    'Dein Warenkorb ist leer.': 'Twój koszyk jest pusty.',
    'Warenkorb wird geladen...': 'Ładowanie koszyka...',
    // lib/paymentStore.svelte.js
    'Wunsch-Zustelldatum konnte nicht gespeichert werden': 'Nie udało się zapisać wybranego terminu dostawy',
    // lib/userStore.svelte.js
    'Login fehlgeschlagen.': 'Logowanie nie powiodło się.',
    // utils/deliveryDate.js
    'Min.': 'min',
    'morgen': 'jutro',
    // oxid-proxy modules/user/service.ts (Meldungen des Proxys)
    'Bitte gib eine gueltige E-Mail-Adresse ein.': 'Podaj prawidłowy adres e-mail.',
    'Bitte gib deinen Namen ein.': 'Podaj imię i nazwisko.',
    'Bitte gib deine Strasse ein.': 'Podaj ulicę.',
    'Bitte gib deine Hausnummer ein.': 'Podaj numer domu.',
    'Bitte gib deine Postleitzahl ein.': 'Podaj kod pocztowy.',
    'Bitte gib deine Stadt ein.': 'Podaj miejscowość.',
    'Bitte waehle ein Land.': 'Wybierz kraj.',
    'Keine Session gefunden.': 'Nie znaleziono sesji.',
    'Adresse nicht gefunden.': 'Nie znaleziono adresu.',
    'E-Mail-Adresse': 'Adres e-mail',
    'Erneut laden': 'Załaduj ponownie',
    'Diese E-Mail-Adresse konnte nicht registriert werden. Hast du bereits ein Kundenkonto bei uns?': 'Nie udało się zarejestrować tego adresu e-mail. Czy masz już u nas konto klienta?',
    'E-Mail-Adresse oder Passwort ungültig.': 'Nieprawidłowy adres e-mail lub hasło.',
    'Zu viele Login-Versuche. Bitte in {minutes} Minute erneut probieren.': 'Zbyt wiele prób logowania. Spróbuj ponownie później (pozostało minut: {minutes}).',
    'Zu viele Login-Versuche. Bitte in {minutes} Minuten erneut probieren.': 'Zbyt wiele prób logowania. Spróbuj ponownie później (pozostało minut: {minutes}).',
    // oxid-proxy modules/basket/service.ts (Warenkorb, Task 191)
    'Sofort Versandbereit': 'Gotowy do natychmiastowej wysyłki',
    'Versandbereit in {days} Tag': 'Gotowy do wysyłki w ciągu {days} dnia',
    'Versandbereit in {days} Tagen': 'Gotowy do wysyłki w ciągu {days} dni',
    'Artikel nicht verfügbar.': 'Produkt jest niedostępny.',
    'Artikel ist leider nicht auf Lager.': 'Niestety tego produktu nie ma w magazynie.',
    'Deine Artikel': 'Twoje produkty',
    'Du sparst': 'Oszczędzasz',
    'Du sparst insgesamt {betrag}': 'Łącznie oszczędzasz {betrag}',
    'Fast geschafft – bitte prüfe kurz Deine Bestellung.': 'Prawie gotowe – sprawdź jeszcze swoje zamówienie.',
    'ehem. UVP': 'dawna cena katalogowa',
    'Warenkorb geändert': 'Koszyk został zmieniony',
    'Bitte wähle easyCredit erneut, damit wir den Betrag aktualisieren können.': 'Wybierz ponownie easyCredit, abyśmy mogli zaktualizować kwotę.',

    // MarketSwitchNotice / Versand nicht möglich (Task 185), zum Lektorat. reference: [lang 2]
    'Lieferung nach {land} über {domain}': 'Dostawa do kraju: {land} przez {domain}',
    'Über diesen Shop liefern wir nicht nach {land}. Auf {domain} bestellst du mit dem Versand und den Preisen dieses Markts. Dein Warenkorb und dein Login kommen mit.': 'Przez ten sklep nie wysyłamy do kraju: {land}. Na {domain} zamówisz z wysyłką i w cenach tego rynku. Twój koszyk i logowanie przeniosą się razem z Tobą.',
    'Zu {domain} wechseln': 'Przejdź na {domain}',
    'Hier bleiben': 'Zostań tutaj',
    'Wähle eine Lieferadresse in einem von uns belieferten Land oder Selbstabholung.': 'Wybierz adres dostawy w kraju, do którego dostarczamy, lub odbiór osobisty.',
    'nicht möglich': 'niedostępna',
};
